import {Accordion, AccordionDetails} from "@mui/material";
import {Category} from "../../types";
import CategoryAccordionSummary from "./CategoryAccordionSummary";
import SubcategoryList from "./SubcategoryList";
import {Dispatch, SetStateAction, SyntheticEvent} from "react";

interface CategoryAccordionProps {
  category: Category;
  selectedCategory: Category | null;
  selectedSubcategory: string;
  setSelectedCategory: Dispatch<SetStateAction<Category | null>>;
  setSelectedSubcategory: Dispatch<SetStateAction<string>>;
  onClose?: () => void;
}

const CategoryAccordion = ({
                             category,
                             selectedCategory,
                             selectedSubcategory,
                             setSelectedCategory,
                             setSelectedSubcategory,
                             onClose
                           }: CategoryAccordionProps) => {
  const handleChange = (event: SyntheticEvent, isExpanded: boolean) => {
    setSelectedCategory(isExpanded ? category : null);
  };

  return (
    <Accordion
      onChange={handleChange}
      expanded={category.id === selectedCategory?.id}
      key={`category-${category.id}`}
      disableGutters
      sx={{
        p: 0,
        backgroundColor: 'white',
        boxShadow: 'none',
        '&.Mui-expanded': {
          backgroundColor: 'white',
        },
      }}
    >
      <CategoryAccordionSummary
        title={category.title}
      />
      <AccordionDetails sx={{p: 0}}>
        <SubcategoryList
          onClose={onClose}
          subcategories={category.subcategories || []}
          selectedSubcategory={selectedSubcategory}
          setSelectedSubcategory={setSelectedSubcategory}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default CategoryAccordion;
